import { render, staticRenderFns } from "./ContentRow.vue?vue&type=template&id=95437f7a&scoped=true"
import script from "./ContentRow.vue?vue&type=script&lang=js"
export * from "./ContentRow.vue?vue&type=script&lang=js"
import style0 from "./ContentRow.vue?vue&type=style&index=0&id=95437f7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95437f7a",
  null
  
)

export default component.exports